export enum Routes {
    Menu = "menu",
    Puzzle = "puzzle",
    Archive = "archive",
    AdminPuzzles = "admin_puzzles"
};

export type Puzzle = {
    id: number;
    date: string;
    fit: number;
    size: number;
    difficulty: number;
    grid: Array<number>;
};

export type Attempt = {
    id?: number;
    puzzle_id: number;
    session: string;
    timer: Timer;
    placements: Array<CellState>;
    snapshots: Array<Array<CellState>>;
    hint_cooldown_until?: number;
    solved: boolean;
    rating?: number;
};

export enum CellState {
    Empty,
    X,
    Star,
    StarInvalid,
}

export type Stats = {
    revealed: boolean;
    hints_used: number;
    solve_time: number;
    attempts_counter: number;
    solved_counter: number;
    avg_time: number;
    percentile: number;
};

export type Recap = {
    puzzle_id: number;
    date: string;
    difficulty: number;
    solve_time: number;
    hints_used: number;
    percentile: number;
    solved_counter: number;
    avg_time: number;
};

export type Timer = {
    paused: boolean;
    elapsed: number;
};

export type Hint = {
    valid: boolean;
    solved: boolean;
    cells: number[];
    text: string;
};

export type AdminPuzzleSummary = {
    id: number;
    date: string;
    fit: number;
    size: number;
    difficulty: number;
    grid: Array<number>;
    attempts_counter: number;
    solved_counter: number;
    avg_time: number;
    avg_hints: number;
};

export type AdminMarkerTop = {
    index: number;
    rate: number;
    count: number;
};

export type AdminRouteNode = {
    sig: string;
    kings: number[];
    king_order?: number[];
    visits: number;
    total_dt: number;
    median_dt: number;
    p95_dt: number;
    hints: number;
    x_top: AdminMarkerTop[];
    x_rate?: number[];
    out_degree: number;
    branch_entropy: number;
    branch_entropy_norm: number;
};

export type AdminRouteEdge = {
    from: string;
    to: string;
    count: number;
    share: number;
    total_dt: number;
    median_dt: number;
    p95_dt: number;
    x_top: AdminMarkerTop[];
    x_rate?: number[];
};

export type AdminPuzzleRoutesResponse = {
    puzzle_id: number;
    size: number;
    fit: number;
    attempts_used: number;
    nodes: AdminRouteNode[];
    edges: AdminRouteEdge[];
};

export type AdminDifficultyParamsResponse = {
    defaults: Record<string, unknown>;
    active: Record<string, unknown>;
    saved: Record<string, unknown>;
};

export type AdminDifficultyParamsSetResponse = {
    ok: boolean;
    active: Record<string, unknown>;
};

export type AdminDifficultyCacheBuildResponse = {
    built: number;
    missing: number;
};

export type AdminDifficultyPreviewItem = {
    puzzle_id: number;
    difficulty: number;
};

export type AdminDifficultyPreviewResponse = {
    items: AdminDifficultyPreviewItem[];
    missing: number[];
};

export type QueuedEvent = {
    id?: number;
    client_event_id: string;
    session: string;
    seq: number;
    event_type: string;
    elapsed_ms?: number;
    client_ts?: number;
    data?: unknown;
    created_at: number;
    next_retry_at: number;
    attempts: number;
};
